<span class="material-symbols-outlined align-middle ps-2" matTooltip="Questionnaire certifiant"> verified </span>
